import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLedCalculatorFormInput',
  props: {
    value: { default: '' },
    label: { default: '' },
    name: null,
    type: { default: 'number' },
    required: { type: Boolean, default: false },
    max: { default: null },
    inputFieldSuffix: { default: '' },
    step: { default: null }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: string | number): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, label: string, name: string, type: string, required: boolean, max: number | null, inputFieldSuffix: string, step: string | number | null }





const inputValue = computed<string | number>({
    get() {
        return props.value;
    },
    set(value: string | number) {
        emit('input', value);
    }
});

const inputValidationObject = computed<object>(() => {
    const ruleSet : any = {
        required: props.required
    };

    if (props.max !== null) {
        ruleSet.max_value = props.max;
    }

    return ruleSet;
});

return { __sfc: true,props, emit, inputValue, inputValidationObject }
}

})